module.exports = __webpack_public_path__ + "static/media/set_local_icon.323a5e50.svg";